import React from "react";
import "./logindesign.css";

function LoginFailedModal({ onClose }) {
  return (
    <div className="modalfail">
      <div className="modal-content-fails">
        <h2 className="lf">Login Failed</h2>
        <p className="msg">Please check your username and password.</p>
        <button className="loginfail" onClick={onClose}>OK</button>
      </div>
    </div>
  );
}

export default LoginFailedModal;
